import { useQuery } from '@tanstack/react-query';
import { useAuthenticatedApi } from '../api';

const fetchPlugYourWork = async (authenticatedFetch, params) => {
  const queryString = new URLSearchParams(params).toString();
  const response = await authenticatedFetch(`${process.env.REACT_APP_API_URL || '/api'}/plug-your-work?${queryString}`);
  
  if (!response.ok) {
    throw new Error('Failed to fetch plug your work entries');
  }
  
  return response.json();
};

export const usePlugYourWork = (params = {}) => {
  const { authenticatedFetch } = useAuthenticatedApi();
  
  return useQuery({
    queryKey: ['plugYourWork', params],
    queryFn: () => fetchPlugYourWork(authenticatedFetch, params),
    staleTime: 2 * 60 * 1000, // 2 minutes
    cacheTime: 5 * 60 * 1000, // 5 minutes
    retry: 1,
    enabled: !!authenticatedFetch, // Only run when authenticated
    refetchOnMount: true,
  });
};
